// extracted by mini-css-extract-plugin
module.exports = {"link":"LinkS_link__DMOll","active":"LinkS_active__3AKdC"};